<div [@visibilityYoutubeVideo]="visibilityYoutubeVideo" class="ytplayer-wrapper" [ngClass]="{'ytplayer-wrapper-big': showMediaplayerLarge}">
    <div id="ytplayer"></div>
</div>

<div *ngIf="mediaplayerVisible && !showMediaplayerLarge" class="ytplayer-wrapper__overlay" (click)="expandMediaplayer()"></div>

    